module.exports = [{"type":"title","text":"2024-08-08"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Coin-M Perpetuals: new WS DataType-ACCOUNT_UPDATE Account balance and position update push"},{"type":"html","text":"Coin-M Perpetuals:new WS DataType-ORDER_TRADE_UPDATE Order update push"},{"type":"html","text":"Coin-M Perpetuals:nwe WS ACCOUNT-CONFIG_UPDATE Configuration updates such as leverage and margin mode"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-08-08.json
// module id = dzxx
// module chunks = 3